import React, { useContext, useRef, useState } from "react";
import { Card, Table } from "@themesberg/react-bootstrap";
import { TableRow } from "../component/TableRow";
import Pagination from "../../../../components/Pagination";
import { Context } from "../Order";
import ImagePreview from "./image-preview/ImagePreview";
import OrderDetailModal from "../component/OrderDetailModal";

const _Table = () => {
  const { state, dispatch } = useContext(Context);

  const [modalImageShow, setModalImageShow] = useState(false);
  const [orderDetailShow, setOrderDetailShow] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);

  const selectedImageRef = useRef("");

  const previewTitleRef = useRef("");

  const showImagePreview = (title, image) => {
    previewTitleRef.current = title;

    selectedImageRef.current = image;

    setModalImageShow(true);
  };

  const showOrderDetail = (order) => {
    setSelectedOrder(order);
    setOrderDetailShow(true);
  };

  return (
    <>
      <Card border="light" className="shadow-sm mb-4 border-0">
        <Card.Body className="p-0">
          <div className="table-responsive">
            <Table
              className="table-centered table-nowrap mb-0 rounded align-middle"
              hover
            >
              <thead className="bg-white border-bottom">
                <tr>
                  <th
                    className="border-bottom text-center py-3 text-uppercase small fw-bold text-muted"
                    scope="col"
                  >
                    Thao tác
                  </th>
                  <th
                    className="border-bottom py-3 text-uppercase small fw-bold text-muted"
                    scope="col"
                  >
                    Mã đơn
                  </th>
                  <th
                    className="border-bottom text-center py-3 text-uppercase small fw-bold text-muted"
                    scope="col"
                  >
                    Giá tiền
                  </th>
                  <th
                    className="border-bottom text-center py-3 text-uppercase small fw-bold text-muted"
                    scope="col"
                  >
                    Vùng miền
                  </th>
                  <th
                    className="border-bottom text-center py-3 text-uppercase small fw-bold text-muted"
                    scope="col"
                  >
                    Chi tiết vé
                  </th>
                  <th
                    className="border-bottom text-center py-3 text-uppercase small fw-bold text-muted"
                    scope="col"
                  >
                    Trúng/Không trúng
                  </th>
                  <th
                    className="border-bottom text-center py-3 text-uppercase small fw-bold text-muted"
                    scope="col"
                  >
                    Trạng thái
                  </th>
                  <th
                    className="border-bottom text-center py-3 text-uppercase small fw-bold text-muted"
                    scope="col"
                  >
                    Người chơi
                  </th>
                  <th
                    className="border-bottom text-center py-3 text-uppercase small fw-bold text-muted"
                    scope="col"
                  >
                    Số lượng vé
                  </th>
                  <th
                    className="border-bottom text-center py-3 text-uppercase small fw-bold text-muted"
                    scope="col"
                  >
                    Hình ảnh
                  </th>
                  <th
                    className="border-bottom text-center py-3 text-uppercase small fw-bold text-muted"
                    scope="col"
                  >
                    Ngày tạo
                  </th>
                  <th
                    className="border-bottom text-center py-3 text-uppercase small fw-bold text-muted"
                    scope="col"
                  >
                    Ngày xuất
                  </th>
                </tr>
              </thead>
              <tbody>
                {state.data.list &&
                  state.data.list.map((pv, index) => (
                    <TableRow
                      handleShowImagePreview={showImagePreview}
                      handleShowOrderDetail={showOrderDetail}
                      rIndex={index}
                      key={`table-keys-lottmekong-${pv.id}`}
                      {...pv}
                    />
                  ))}
                {(!state.data.list || state.data.list.length === 0) && (
                  <tr>
                    <td colSpan="12" className="text-center py-5 text-muted">
                      <div className="fs-5">Chưa có dữ liệu</div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </Card.Body>
        <Card.Footer className="px-3 border-0 d-flex flex-column flex-lg-row align-items-center justify-content-between">
          <div className="fw-normal small mt-1 mt-lg-0 text-muted">
            Hiển thị <b>{state.data.list?.length || 0}</b> trong tổng{" "}
            <b>{state.data.total || 0}</b> đơn hàng
          </div>
          <Pagination
            totalPage={state.data.totalPage || 0}
            currentPage={state.filter.page || 0}
            onPageChange={(i) => {
              dispatch({
                type: "UPDATE_PAGE",
                payload: i,
              });
            }}
          />
        </Card.Footer>
      </Card>
      <ImagePreview
        show={modalImageShow}
        title={previewTitleRef.current}
        image={selectedImageRef.current}
        onHide={() => setModalImageShow(false)}
      />
      <OrderDetailModal
        show={orderDetailShow}
        order={selectedOrder}
        onHide={() => {
          setOrderDetailShow(false);
          setSelectedOrder(null);
        }}
      />
    </>
  );
};

export default React.memo(_Table);
